import {
  Button,
  Div,
  HeaderBack,
  ImageView,
  Label,
  LoadingIndicator,
} from 'components';
import {Ecolors, Efonts, Icons} from 'constant';
import React, {useEffect, useState} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {getStatusEditProfile} from 'reducer/authen/selector';
import {apiAuth, navigate, useImageUrl} from 'services';
import {apiMain} from 'services/apis/apiMain';
import {useAppSelector} from 'store/hooks';
import {convertTimestamp, widthScale, widthScreen} from 'utils';
import {convertchangeIdNoStatus} from '../ChangeCMNDtoCCCDScreen/api';

function RowSpaceItem(p: {paddingTop?: number; children?: any}) {
  return (
    <Div
      height={54}
      paddingHorizontal={16}
      borderBottomWidth={1}
      borderBottomColor={Ecolors.spaceColor}
      paddingTop={p.paddingTop ?? 0}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}>
      {p.children && p.children}
    </Div>
  );
}

function AccountInfoModal() {
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const [loading, setLoading] = useState<boolean>(false);
  const [country, setCountry] = useState<any>(null);
  const [typeId, setTypeId] = useState<any>({});
  const isEdit = useAppSelector(state => getStatusEditProfile(state));

  const [photoAfter, setPhotoAfter] = useState<any>(null);
  const [photoBefore, setPhotoBefore] = useState<any>(null);
  const [photoFace, setPhotoFace] = useState<any>(null);

  const {
    email,
    phone,
    name,
    gender,
    dob,
    idTypeId,
    idNo,
    dateOfIssue,
    placeOfIssue,
    mailingCountryId,
    nationalityId,
    userPhotos,
    investorTypeId,
    countryId,
    visaNo,
    changeIdNoStatus,
    changeIdNo,
  } = currentUser;

  const [photoAfterUrl] = useImageUrl(
    `download/file-for-link`,
    'POST',
    photoAfter?.url ?? '',
  );

  const [photoBeforeUrl] = useImageUrl(
    `download/file-for-link`,
    'POST',
    photoBefore?.url ?? '',
  );

  const [photoFaceUrl] = useImageUrl(
    `download/file-for-link`,
    'POST',
    photoFace?.url ?? '',
  );

  useEffect(() => {
    getCountry();
    getSource();
    return () => {};
  }, [currentUser]);

  useEffect(() => {
    userPhotos.forEach(item => {
      switch (item?.photoType?.code) {
        case 'AVATAR':
          setPhotoFace(item);
          break;
        case 'IDENTITY_CARD_1':
          setPhotoBefore(item);
          break;
        case 'IDENTITY_CARD_2':
          setPhotoAfter(item);
          break;
      }
    });
  }, [userPhotos]);

  const getSource = async () => {
    try {
      if (investorTypeId == 2) {
        const listForOrg = await apiAuth.listForOrg();
        if (listForOrg.status == 200) {
          setTypeId(listForOrg.data.find((item: any) => item.id == idTypeId));
        }
        return;
      }
      const listForIndivi = await apiAuth.listForIndivi();
      if (listForIndivi.status == 200) {
        setTypeId(listForIndivi.data.find((item: any) => item.id == idTypeId));
      }
    } catch (error) {}
  };

  const getCountry = async () => {
    try {
      const res = await apiMain.getCountry();
      const c = res.data.find(
        (a: any) => a.id == mailingCountryId || a.id == nationalityId,
      );
      if (c) {
        setCountry(c);
      }
    } catch (error) {}
  };

  const CCCDItem = [photoBeforeUrl?.url, photoAfterUrl?.url];

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={2}
        iconRight={isEdit ? Icons.edit : changeIdNo == 1 ? Icons.edit : null}
        loading={loading}
        title={`accountverify.thongtincanhan`}
        onRightPress={() => {
          if (loading) {
            return;
          }
          if (changeIdNo == 1) {
            navigate('ChangeCMNDtoCCCDScreen');
            return;
          }
          navigate('EditAccountInfoModal');
        }}
      />

      {!!changeIdNoStatus && (
        <Button
          onPress={() => {
            navigate('ChangeCMNDtoCCCDDetailsScreen', {change: 'cccd'});
          }}>
          <RowSpaceItem>
            <Label>{`changecmnd.trangthaihoso`}</Label>
            <Div
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end">
              <Label
                fontFamily={Efonts.italic}
                color={convertchangeIdNoStatus(changeIdNoStatus).color}
                multilanguage={false}>
                {convertchangeIdNoStatus(changeIdNoStatus).title}
              </Label>
              <ImageView
                marginLeft={5}
                widthHeight={12}
                source={Icons.forward}
                resizeMode="contain"
              />
            </Div>
          </RowSpaceItem>
        </Button>
      )}

      <ScrollView>
        <Div
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}
          paddingHorizontal={16}
          height={48}
          backgroundColor={'rgba(73, 85, 163, 0.1)'}>
          <Label>{`accountverify.thongtinnhadautu`}</Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.hoten`}</Label>
          <Label multilanguage={false}>{name}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.gioitinh`}</Label>
          <Label>
            {gender === 1 ? `accountverify.nam` : `accountverify.nu`}
          </Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.ngaysinh`}</Label>
          <Label multilanguage={false}>{convertTimestamp(dob)}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.quoctich`}</Label>
          <Label multilanguage={false}>{country?.name || ''}</Label>
        </RowSpaceItem>
        {nationalityId != 234 && (
          <RowSpaceItem>
            <Label>{`accountverify.sothithucnhapcanh`}</Label>
            <Label multilanguage={false}>{visaNo || ''}</Label>
          </RowSpaceItem>
        )}
        <RowSpaceItem>
          <Label>{`accountverify.email`}</Label>
          <Label multilanguage={false}>{email}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.sodienthoai`}</Label>
          <Label multilanguage={false}>{phone}</Label>
        </RowSpaceItem>
        {/*  */}
        <Div
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}
          paddingHorizontal={16}
          height={48}
          backgroundColor={'rgba(73, 85, 163, 0.1)'}>
          <Label>{`accountverify.thongtincmnd`}</Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.loaigiayto`}</Label>
          <Div
            flex={1}
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end">
            <Label textAlign="right" multilanguage={false}>
              {typeId?.name || ''}
            </Label>
          </Div>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.sohieugiayto`}</Label>
          <Label multilanguage={false}>{idNo}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.ngaycap`}</Label>
          <Label multilanguage={false}>{convertTimestamp(dateOfIssue)}</Label>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.noicap`}</Label>
          <Div
            flex={1}
            flexDirection={'row'}
            paddingLeft={10}
            alignItems={'center'}
            justifyContent={'flex-end'}>
            <Label textAlign="right" multilanguage={false}>
              {placeOfIssue}
            </Label>
          </Div>
        </RowSpaceItem>
        {loading && (
          <Div alignItems={'center'} paddingTop={10} justifyContent={'center'}>
            <LoadingIndicator color={Ecolors.mainColor} numdot={3} />
          </Div>
        )}
        <Div
          padding={16}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          {CCCDItem?.map((item: string, index: number) => {
            if (!item) return <></>;
            return (
              <Div
                width={162}
                overflow={'hidden'}
                height={140}
                key={index}
                borderRadius={5}
                borderWidth={1}
                borderColor={Ecolors.bordercolor}>
                <ImageView
                  resizeMode="cover"
                  width={162}
                  height={140}
                  source={{
                    uri: item,
                  }}
                />
              </Div>
            );
          })}
        </Div>
        {photoFaceUrl?.url && investorTypeId != 2 && (
          <>
            <Div
              justifyContent={'center'}
              paddingHorizontal={16}
              height={48}
              backgroundColor={'rgba(73, 85, 163, 0.1)'}>
              <Label>{`accountverify.faceImgTitle`}</Label>
            </Div>

            <Div
              width={103}
              overflow={'hidden'}
              height={162}
              borderRadius={5}
              borderWidth={1}
              borderColor={Ecolors.bordercolor}
              marginLeft={16}
              marginTop={16}>
              <ImageView
                width={103}
                height={162}
                source={{
                  uri: photoFaceUrl?.url,
                }}
              />
            </Div>
          </>
        )}

        <Div height={200} />
      </ScrollView>
    </Div>
  );
}

const s = StyleSheet.create({
  imgContainer: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: widthScale(200),
  },
  sbutton: {
    width: widthScreen - widthScale(30),
    height: widthScale(200),
  },
});

export default AccountInfoModal;
